import { render } from "./Todo.vue?vue&type=template&id=71902966"
import script from "./Todo.vue?vue&type=script&lang=ts"
export * from "./Todo.vue?vue&type=script&lang=ts"
script.render = render

export default script